import styled from 'styled-components';


export const PaginaAuth = styled.div`

    min-height: 100vh;
    background: #FFFFFF;
    color: #646464;

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

`;


export const HeaderAuth = styled.header`

    width: 100%;
    min-height: 72px;

    padding: 12px 5%;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;

    border-bottom: 1px solid rgba(100, 100, 100, 0.10);
    background: #FFFFFF;

`;


export const LogoLink = styled.a`

    display: inline-flex;
    align-items: center;
    text-decoration: none;

`;


export const Logo = styled.img`

    display:
        block;

    width:
        170px;

    height:
        auto;

    max-width:
        100%;

    object-fit:
        contain;

`;


export const HeaderAcciones = styled.div`

    display: flex;
    align-items: center;
    gap: 10px;

`;


export const LinkHeader = styled.a`

    min-height: 38px;

    padding: 7px 15px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    border: 1px solid rgba(35, 170, 175, 0.30);
    border-radius: 9px;

    color: #23AAAF;
    background: #FFFFFF;

    font-size: 0.78rem;
    font-weight: 750;

    text-decoration: none;

    transition: 0.16s ease;


    &:hover {
        background: rgba(35, 170, 175, 0.06);
    }


    @media (max-width: 600px) {

        padding: 7px 10px;
        font-size: 0.72rem;

    }

`;


/*
========================================
CONTENIDO
========================================
*/

export const ContenidoAuth = styled.main`

    width: min(1120px, calc(100% - 40px));

    margin: 0 auto;
    padding: 48px 0 70px;

    display: grid;
    grid-template-columns:
        minmax(300px, 0.95fr)
        minmax(380px, 1.05fr);

    align-items: center;
    gap: 70px;


    @media (max-width: 900px) {

        width: min(620px, calc(100% - 28px));

        grid-template-columns: 1fr;
        gap: 30px;

        padding: 35px 0 60px;

    }


    @media (max-width: 520px) {

        width: calc(100% - 20px);
        padding: 22px 0 45px;

    }

`;


/*
========================================
ILUSTRACIÓN
========================================
*/

export const PanelIlustracion = styled.div`

    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 0;


    @media (max-width: 900px) {

        display: none;

    }

`;


export const ImagenAuth = styled.img`

    display: block;

    width: min(100%, 500px);
    max-height: 470px;

    object-fit: contain;

`;


/*
========================================
FORMULARIO
========================================
*/

export const TarjetaAuth = styled.section`

    width: 100%;
    max-width: 500px;

    justify-self: center;

    padding: 30px;

    border: 1px solid rgba(35, 170, 175, 0.18);
    border-radius: 17px;

    background: #FFFFFF;

    box-shadow:
        0 7px 28px
        rgba(0, 0, 0, 0.04);


    @media (max-width: 520px) {

        padding: 22px 17px;

    }

`;


export const EncabezadoAuth = styled.div`

    margin-bottom: 22px;

`;


export const TituloAuth = styled.h1`

    margin: 0;

    color: #333333;

    font-size: clamp(1.25rem, 3vw, 1.55rem);
    font-weight: 800;

    line-height: 1.25;

`;


export const TextoAuth = styled.p`

    margin: 7px 0 0;

    color: #646464;

    font-size: 0.82rem;
    line-height: 1.55;

`;


/*
========================================
TIPO CUENTA
========================================
*/

export const EtiquetaGrupo = styled.div`

    margin-bottom: 7px;

    color: #646464;

    font-size: 0.68rem;
    font-weight: 750;

    text-transform: uppercase;
    letter-spacing: 0.03em;

`;


export const TipoGrid = styled.div`

    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));

    gap: 8px;

    margin-bottom: 20px;


    @media (max-width: 440px) {

        grid-template-columns: 1fr;

    }

`;


export const TipoButton = styled.button`

    min-height: 38px;

    padding: 7px 10px;

    border:
        1.5px solid
        #FC8906;

    border-radius: 999px;

    background:
        ${
            props =>
                props.$activo
                    ? '#F5A54B'
                    : '#FFFFFF'
        };

    color:
        ${
            props =>
                props.$activo
                    ? '#FFFFFF'
                    : '#FC8906'
        };

    font-family: inherit;
    font-size: 0.73rem;
    font-weight: 750;

    cursor: pointer;

    transition: 0.15s ease;


    &:hover {

        background:
            ${
                props =>
                    props.$activo
                        ? '#F5A54B'
                        : 'rgba(252, 137, 6, 0.06)'
            };

    }

`;


/*
========================================
FORM
========================================
*/

export const FormularioAuth = styled.form`

    width: 100%;

`;


export const CampoAuth = styled.div`

    margin-bottom: 14px;

`;


export const LabelAuth = styled.label`

    display: block;

    margin-bottom: 5px;

    color: #646464;

    font-size: 0.71rem;
    font-weight: 750;

`;


export const InputAuth = styled.input`

    width: 100%;
    min-height: 43px;

    padding: 10px 12px;

    border: 1.5px solid rgba(100, 100, 100, 0.24);
    border-radius: 8px;

    outline: none;

    background: #FFFFFF;
    color: #444444;

    font-family: inherit;
    font-size: 0.84rem;

    transition: 0.15s ease;


    &:focus {

        border-color: #23AAAF;

        box-shadow:
            0 0 0 3px
            rgba(35, 170, 175, 0.07);

    }


    &:disabled {

        opacity: 0.6;

    }

`;


/*
========================================
PASSWORD
========================================
*/

export const CampoPassword = styled.div`

    position: relative;

`;


export const InputPassword = styled(InputAuth)`

    padding-right: 45px;

`;


export const BotonOjo = styled.button`

    position: absolute;

    top: 50%;
    right: 12px;

    transform: translateY(-50%);

    width: 26px;
    height: 26px;

    padding: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 0;
    background: transparent;

    cursor: pointer;

`;


export const IconoOjo = styled.img`

    width: 17px;
    height: 17px;

    object-fit: contain;
    opacity: 0.65;

`;


/*
========================================
BOTONES
========================================
*/

export const BotonPrincipalAuth = styled.button`

    width: 100%;
    min-height: 43px;

    margin-top: 5px;

    padding: 9px 18px;

    border: 1px solid #148A8E;
    border-radius: 999px;

    background: #148A8E;
    color: #FFFFFF;

    font-family: inherit;
    font-size: 0.82rem;
    font-weight: 800;

    cursor: pointer;

    transition: 0.16s ease;


    &:hover:not(:disabled) {

        background: #117C80;

        box-shadow:
            0 5px 14px
            rgba(35, 170, 175, 0.17);

    }


    &:disabled {

        opacity: 0.55;
        cursor: not-allowed;

    }

`;


/*
========================================
LINKS
========================================
*/

export const LinksAuth = styled.div`

    margin-top: 12px;

    display: flex;
    justify-content: center;

`;


export const LinkAuth = styled.a`

    color: #148A8E;

    font-size: 0.72rem;
    font-weight: 750;

    text-decoration: none;


    &:hover {

        text-decoration: underline;

    }

`;


/*
========================================
MENSAJES
========================================
*/

export const MensajeAuth = styled.div`

    margin-top: 14px;

    padding: 10px 12px;

    border:
        1px solid
        ${
            props =>
                props.$error
                    ? 'rgba(215, 105, 112, 0.30)'
                    : 'rgba(35, 170, 175, 0.25)'
        };

    border-radius: 8px;

    background:
        ${
            props =>
                props.$error
                    ? 'rgba(215, 105, 112, 0.06)'
                    : 'rgba(35, 170, 175, 0.06)'
        };

    color:
        ${
            props =>
                props.$error
                    ? '#D76970'
                    : '#23AAAF'
        };

    font-size: 0.76rem;
    font-weight: 650;

    line-height: 1.45;

`;


export const AyudaPassword = styled.div`

    margin: 7px 0 15px;

    color: #646464;

    font-size: 0.70rem;
    line-height: 1.45;

`;


export const SeparadorAuth = styled.div`

    width: 100%;
    height: 1px;

    margin: 20px 0;

    background: rgba(100, 100, 100, 0.10);

`;